import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

import ReactDOM from "react-dom/client";
import "react-image-crop/dist/ReactCrop.css";
import "react-image-lightbox/style.css";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import App from "./app/PanelApp.jsx";
import "./index.css";
import store from "./shared/state/store.js";
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <Provider store={store}>
    <CacheProvider value={cacheRtl}>
      <App />
    </CacheProvider>
  </Provider>
);
